
import { defineComponent, ref, PropType } from "vue";

const __default__ = defineComponent({
  name: "StreamContainer",

  props: {
    localStream: MediaStream,
    remoteStreams: Object as PropType<Record<string, MediaStream>>,
  },

  setup() {
    return {
      root: ref<HTMLDivElement | null>(null),
    };
  },

  data() {
    return {
      observer: null as ResizeObserver | null,
      height: 0,
      width: 0,
      videoWidth: "0px",
      videoHeight: "0px",
    };
  },

  computed: {
    streamCount() {
      return this.remoteStreams
        ? Object.keys(this.remoteStreams).length + 1
        : 1;
    },
  },

  watch: {
    height() {
      this.updateStreamSize();
    },

    width() {
      this.updateStreamSize();
    },

    streamCount() {
      this.updateStreamSize();
    },
  },

  mounted() {
    if (this.root) {
      this.observer = new ResizeObserver(() => {
        if (this.root) {
          this.height = this.root.clientHeight;
          this.width = this.root.clientWidth;
        }
      });

      this.observer.observe(this.root);
    }
  },

  umounted() {
    this.observer?.disconnect();
  },

  methods: {
    updateStreamSize() {
      const videoWidth =
        [...Array(this.width).keys()].reverse().find((width) => {
          const height = Math.ceil((9 * width) / 16);
          const columns = Math.floor(this.width / width);
          const rows = Math.ceil(this.streamCount / columns);
          return (
            columns * rows >= this.streamCount && rows * height <= this.height
          );
        }) ?? 0;

      const videoHeight = Math.ceil((9 * videoWidth) / 16);

      this.videoWidth = `${videoWidth}px`;
      this.videoHeight = `${videoHeight}px`;
    },
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "21ccf61a": (_ctx.videoWidth),
  "03fa595a": (_ctx.videoHeight)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__